import { render, staticRenderFns } from "./MatchHeader.vue?vue&type=template&id=7e6099f7&"
import script from "./MatchHeader.vue?vue&type=script&lang=js&"
export * from "./MatchHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports